import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import images from "../../../../ressources/images";
import "./ProfileCourses.scss";
import Filters from "../../../../components/Filters/Filters";
import InsLoader from "../../../../components/InsLoader/InsLoader";
import { allCourses } from "../../../../api/account";
import FormationItem from "../../../../components/FormationItem/FormationItem";
import OneHrFormationItem from "components/FormationItem/OneHrFormationItem";

const Item = ({ item }) => {
  if (item.type === "course") {
    return (
      <FormationItem
        idFormation={item.id}
        image={item.picture}
        title={item.title}
        brand={item.extra.brand.name}
        points={item.extra.points}
        time={item.extra.duration}
        pourcent={item.extra.progression}
      />
    );
  }

  // Soit fini à 100% soit 50% pour dire "en cours", soit 0%
  const percent = item.extra.completed_at
    ? 100
    : item.extra.timeSpentOnCourse > 0
    ? 50
    : 0;

  return (
    <OneHrFormationItem
      id={item.courseID}
      percent={percent}
      duration={item.extra.duration}
      title={item.title}
      image={item.picture}
    />
  );
};

function ProfileCourses(props) {
  const [nav, setNav] = useState("validate");
  const [filters, setFilters] = useState(false);
  const [succeedCourses, setSucceedCourses] = useState([]);
  const [startedCourses, setStartedCourses] = useState([]);
  const [loader, setLoader] = useState(true);

  const toggleNav = (input) => {
    setNav(input);
  };

  const getCourses = () => {
    allCourses({}).then((data) => {
      // setSucceedCourses(data.succeed);
      setSucceedCourses(data.success);
      setStartedCourses(data.started);
    });

    setLoader(false);
  };

  const applyFilters = (filters) => {
    allCourses(filters).then((data) => {
      setSucceedCourses(data.success);
      setStartedCourses(data.started);
      setFilters(false);
    });
  };

  const { t, i18n } = props;

  useEffect(() => {
    getCourses();
  }, [i18n.language]);

  return (
    <div className="my_courses bg_white">
      <div className="header">
        <Link
          className="backlink"
          to={{
            pathname: "/profile",
            state: { nav: "points", transitionName: "slide_out" },
          }}
        >
          <img src={images.arrow_left_black} alt="" />
        </Link>
        <div className="title">{t("my_courses")}</div>
        <div className="filter" onClick={() => setFilters(true)}>
          <img src={images.wall_icon_filter} alt="" />
        </div>
      </div>

      <div className="nav">
        <div
          className={nav === "validate" ? "validate active" : "validate"}
          onClick={() => {
            toggleNav("validate");
          }}
        >
          {t("validate_courses")}
        </div>
        <div
          className={
            nav === "in_progress" ? "in_progress active" : "in_progress"
          }
          onClick={() => {
            toggleNav("in_progress");
          }}
        >
          {t("in_progress")}
        </div>
      </div>

      <div className="content">
        {loader ? (
          <InsLoader />
        ) : nav === "validate" ? (
          <div className="validate_courses">
            {succeedCourses.map((item, index) => (
              <Item key={index} item={item} />
            ))}
          </div>
        ) : (
          <div className="in_progress_courses">
            {startedCourses.map((item, index) => (
              <Item key={index} item={item} />
            ))}
          </div>
        )}
      </div>
      <Filters
        filters={filters}
        close={() => {
          setFilters(false);
        }}
        applyFilters={applyFilters}
      />
    </div>
  );
}

export default withTranslation()(ProfileCourses);
